import Nav from '../../Global/Nav.vue'
export default {
  name: 'Emails',
  components: {
    Nav
  },
  data() {
    return {
      activeName: 'total-view',
      uploadApi: this.$axios.defaults.baseURL + 'excel/upload',
      headersObj: {
        'x-authorization-token': this.$userinfo.api_token
      },
      keywords: '',
      exportSendStatsVisible: false,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      exportSendStatsForm: {
        dates: null,
        user: [],
        product: ''
      },
      exportSendStatsLoading: false,
      save_btn_loading: false,
      save_btn_disabled: false,
      users: [],
      products: [],
      screenSentData: [],
      countries: [],
      uploadExcelVisable: false,
      uploadReceiversVisable: false,
      excelPreviewVisible: false,
      uploadExcelForm: {
        country: null,
        language: '英语'
      },
      lettersFileList: [],
      receiversFileList: [],
      uploadExcelFileName: '',
      uploadExcelData: [],
      lettersList: [],
      receiversList: [],
      uploadReceiversData: [],
      uploadReceiversForm: {
        country: null,
        product: null
      },
      uploadReceiversRules: {
        product: [
          { required: true, message: '产品不能为空', trigger: 'commit' }
        ]
      },
      receiversPreviewVisible: false,
      uploadReceiversFileName: '',
      repliersList: [],
      addRepliersVisable: false,
      repliersForm: {},
      sendersList: [],
      addSendersVisable: false,
      sendersForm: {
        mailer: 'smtp',
        encryption: null,
        host: '',
        port: 25,
        username: '',
        password: ''
      },
      sendersRules: {
        host: [
          { required: true, message: '服务器不能为空', trigger: 'commit' }
        ],
        username: [
          { required: true, message: '用户名不能为空', trigger: 'commit' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'commit' }
        ]
      },
      editSendersVisable: false,
      editSendersForm: {
        mailer: 'smtp',
        encryption: null,
        host: '',
        port: 25,
        username: '',
        password: ''
      },
      mailerOptions: [
        {
          label: 'smtp',
          value: 'smtp'
        }
      ],
      loading: false,
      email_sender_loading: false,
      addTaskVisable: false,
      taskList: [],
      taskForm: {
        task_name: '',
        letter_id: '',
        receivers_id: '',
        sender_id: '',
        delay: false,
        start_time: '',
        from_address: '',
        from_name: '',
        send_interval: 30,
        send_mode: '普通模式',
        multi_sender_id: '',
        cut_density: 50,
        cut_mode: '顺序',
        round_space: '48',
        mixed: false
      },
      detailTaskForm: {},
      detailTaskVisable: false,
      detailLoading: false,
      detailTaskLoadingText: '请稍候',
      send_rounds: 4,
      current_receiver_count: '',
      lettersOptions: [],
      receiversOptions: [],
      senderOptions: [],
      taskStartTimeVisable: false,
      taskRules: {
        task_name: [
          { required: true, message: '任务名称不能为空', trigger: 'commit' }
        ],
        from_name: [
          { required: true, message: '实显发件人不能为空', trigger: 'commit' }
        ],
        send_interval: [
          { required: true, message: '发送间隔不能为空', trigger: 'commit' },
          { type: 'number', min: 10, message: '不能低于10秒', trigger: 'change' }
        ]
      },
      sentStats: [],
      viewTaskDetailName: '',
      viewTaskDetailVisible: false,
      viewTaskDetailData: [],
      viewTaskDetailForm: {
        option: 'all',
        roundOption: 0
      },
      viewTaskDetailRow: {},
      viewTaskDetailOptions: [
        {
          key: 'all',
          value: '全部'
        },
        {
          key: 'read',
          value: '已读'
        },
        {
          key: 'unread',
          value: '未读'
        }
      ],
      viewTaskDetailRoundOptions: [],
      interval: '',
      sentStatsKeywords: '',
      sentStatsTotal: 0,
      sentStatsSize: 10,
      sentStatsCurrentPage: 1,
      taskListKeywords: '',
      taskListTotal: 0,
      taskListSize: 10,
      taskListCurrentPage: 1,
      letterListKeywords: '',
      letterListTotal: 0,
      letterListSize: 10,
      letterListCurrentPage: 1,
      receiversListKeywords: '',
      receiversListTotal: 0,
      receiversListSize: 10,
      receiversListCurrentPage: 1,
      sendersListKeywords: '',
      sendersListTotal: 0,
      sendersListSize: 10,
      sendersListCurrentPage: 1,
      taskRecycleBin: false,
      taskRecycleBinData: [],
      taskRecycleTotal: 0,
      taskRecycleSize: 10,
      taskRecycleCurrentPage: 1,
      rest_senders: {
        rest_senders1: ''
      },
      sentStatsLoading: false,
      sentStatsDetailLoading: false,
      isTurnMode: false,
      vLoading: false,
      sLoading: false
    }
  },
  mounted() {
    // 发送统计
    this.getSendStats()
    // 构建echarts
    // this.drawCharts()
    this.$axios.get('/basic/world_city_list', {
      params: {
        parent_id: 0
      }
    }).then((response) => {
      if (response.data.code === 200) {
        this.countries = response.data.data;
      }
    });
    this.intervals = setInterval(() => {
      if (this.activeName === 'total-view') {
        // this.getSendStats();
      } else if (this.activeName === 'task') {
        this.taskQueryList(true);
      }
    }, 30000);
  },
  computed: {
    combinedSenders() {
      const combinedSenders = {};
      for (let i = 1; i <= this.send_rounds; i++) {
        if (this.rest_senders[i] !== '' && this.rest_senders[i] !== undefined) {
          combinedSenders[i] = this.rest_senders[i];
        }
      }
      return combinedSenders;
    }
  },
  methods: {
    getSendStats() {
      this.sentStatsLoading = true
      this.$axios.get(`email/sent_stats`, {
        params: {
          keywords: this.sentStatsKeywords,
          size: this.sentStatsSize,
          page: this.sentStatsCurrentPage
        }
      }).then((response) => {
        this.sentStatsLoading = false;
        if (response.data.code === 200) {
          this.sentStats = response.data.data.data
          this.sentStatsTotal = response.data.data.total
        }
      });
    },
    changeSentStatsSize(val) {
      this.sentStatsSize = val;
      this.getSendStats();
    },
    CurrentSentStatsChange(val) {
      this.sentStatsCurrentPage = val;
      this.getSendStats();
    },
    setTaskDetailOption(event) {
      this.viewTaskDetailForm.option = event;
      setTimeout(() => {
        this.getTaskDetail()
      })
    },
    setTaskDetailRoundOption(event) {
      this.viewTaskDetailForm.roundOption = event;
      setTimeout(() => {
        this.getTaskDetail()
      })
    },
    setTaskDetailRow(row) {
      this.viewTaskDetailRoundOptions = [];
      if (row.send_mode === '轮换模式') {
        row.turn_mode_senders.forEach((value, key) => {
          this.viewTaskDetailRoundOptions.push({
            key: key,
            value: value
          })
        });
        this.isTurnMode = true
      } else {
        this.isTurnMode = false
      }
      this.viewTaskDetailRow = row;
      setTimeout(() => {
        this.getTaskDetail()
      })
    },
    getTaskDetail() {
      this.sentStatsDetailLoading = true;
      this.viewTaskDetailName = this.viewTaskDetailRow.task_name
      this.viewTaskDetailVisible = true;
      let task_id = this.viewTaskDetailRow.task_id;
      let option = this.viewTaskDetailForm.option;
      let round = this.viewTaskDetailForm.roundOption;
      let send_mode = this.viewTaskDetailRow.send_mode;
      this.$axios.get(`email/task_detail?task_id=${task_id}&option=${option}&round=${round}&send_mode=${send_mode}`).then((response) => {
        this.sentStatsDetailLoading = false;
        if (response.data.code === 200) {
          this.viewTaskDetailData = response.data.data
        }
      });
    },
    viewTaskDetailSaveAs() {
      window.location.href = this.$axios.defaults.baseURL + 'email/task_detail_save_as?task_id=' + this.viewTaskDetailRow.task_id + '&option=' + this.viewTaskDetailForm.option + '&round=' + this.viewTaskDetailForm.roundOption + '&send_mode=' + this.viewTaskDetailRow.send_mode;
    },
    drawCharts() {
      let myChart1 = this.$echarts.init(document.getElementById('main1'))
      let option = {
        xAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: 'line',
            smooth: true
          }
        ]
      };
      myChart1.setOption(option)
    },
    tabClick(tab, event) {
      switch (tab.name) {
        case 'total-view':
          this.getSendStats();
          break;
        case 'task':
          this.taskQueryList();
          setTimeout(() => {
            this.initOptions();
          }, 0);
          break;
        case 'letters':
          this.developLettersList();
          break;
        case 'receivers':
          this.receiversQueryList();
          break;
        case 'repliers':
          this.repliersQueryList();
          break;
        case 'senders':
          this.sendersQueryList();
          break;
        case 'recycle':
          this.queryRecycleList();
          break;
      }
    },
    developLettersList: function () {
      this.vLoading = true;
      this.$axios.get('email/develop_letters/list', {
        params: {
          keywords: this.letterListKeywords,
          page: this.letterListCurrentPage,
          size: this.letterListSize
        }
      }).then((response) => {
        this.vLoading = false;
        if (response.data.code === 200) {
          this.lettersList = response.data.data.data;
          this.letterListTotal = response.data.data.total;
        }
      })
    },
    changeLetterListSize(val) {
      this.letterListSize = val;
      this.developLettersList();
    },
    CurrentLetterListChange(val) {
      this.letterListCurrentPage = val;
      this.developLettersList();
    },
    receiversQueryList: function () {
      this.vLoading = true;
      this.$axios.get('email/receivers/list', {
        params: {
          keywords: this.receiversListKeywords,
          page: this.receiversListCurrentPage,
          size: this.receiversListSize
        }
      }).then((response) => {
        this.vLoading = false;
        if (response.data.code === 200) {
          this.receiversList = response.data.data.data;
          this.receiversListTotal = response.data.data.total;
        }
      })
    },
    changeReceiversListSize(val) {
      this.receiversListSize = val;
      this.receiversQueryList();
    },
    CurrentReceiversListChange(val) {
      this.receiversListCurrentPage = val;
      this.receiversQueryList();
    },
    repliersQueryList: function () {
      this.vLoading = true;
      this.$axios.get('email/repliers/list', {
        params: {
          keywords: this.keywords
        }
      }).then((response) => {
        this.vLoading = false;
        if (response.data.code === 200) {
          this.repliersList = response.data.data.data;
        }
      })
    },
    sendersQueryList: function () {
      this.vLoading = true;
      this.$axios.get('email/senders/list', {
        params: {
          keywords: this.sendersListKeywords,
          page: this.sendersListCurrentPage,
          size: this.sendersListSize
        }
      }).then((response) => {
        this.vLoading = false;
        if (response.data.code === 200) {
          this.sendersList = response.data.data.data;
          this.sendersListTotal = response.data.data.total;
        }
      })
    },
    changeSendersListSize(val) {
      this.sendersListSize = val;
      this.sendersQueryList();
    },
    CurrentSendersListChange(val) {
      this.sendersListCurrentPage = val;
      this.sendersQueryList();
    },
    taskQueryList: function (iv = false) {
      if (iv === false) {
        this.vLoading = true;
      }
      this.$axios.get('email/task/list', {
        params: {
          keywords: this.taskListKeywords,
          page: this.taskListCurrentPage,
          size: this.taskListSize
        }
      }).then((response) => {
        this.vLoading = false;
        if (response.data.code === 200) {
          this.taskList = response.data.data.data;
          this.taskListTotal = response.data.data.total;
        }
      })
    },
    changeTaskListSize(val) {
      this.taskListSize = val;
      this.taskQueryList();
    },
    CurrentTaskListChange(val) {
      this.taskListCurrentPage = val;
      this.taskQueryList();
    },
    lettersUploadSuccess: function (response) {
      this.lettersFileList = [];
      if (response.code === 200) {
        this.lettersFileList.push(response.data)
      } else {
        this.$notify({
          title: 'failed',
          message: response.data,
          type: 'warning'
        })
      }
    },
    cancelLettersUpload: function () {
      this.lettersFileList = [];
      this.uploadExcelVisable = false
    },
    receiversUploadSuccess: function (response) {
      this.receiversFileList = [];
      if (response.code === 200) {
        this.receiversFileList.push(response.data)
      } else {
        this.$notify({
          title: 'failed',
          message: response.data,
          type: 'warning'
        })
      }
    },
    cancelReceiversUpload: function () {
      this.receiversFileList = [];
      this.uploadReceiversVisable = false
    },
    submitLettersPreview: function () {
      let url = this.lettersFileList[0].url;
      this.$axios.get('excel/preview', {
        params: {
          url: url
        }
      }).then((response) => {
        let code = response.data.code;
        if (code === 200) {
          this.uploadExcelFileName = this.lettersFileList[0].name;
          this.uploadExcelData = response.data.data
          this.excelPreviewVisible = true;
        } else {
          this.$notify({
            title: 'error',
            message: response.data.data,
            type: 'error'
          })
        }
      });
    },
    submitReceiversPreview: function () {
      let url = this.receiversFileList[0].url;
      this.$axios.get('excel/preview', {
        params: {
          url: url
        }
      }).then((response) => {
        let code = response.data.code;
        if (code === 200) {
          this.uploadReceiversFileName = this.receiversFileList[0].name;
          this.uploadReceiversData = response.data.data
          this.receiversPreviewVisible = true;
        } else {
          this.$notify({
            title: 'error',
            message: response.data.data,
            type: 'error'
          })
        }
      });
    },
    saveLettersUpload: function () {
      this.$axios.post('email/develop_letters/save', {
        country: this.uploadExcelForm.country,
        language: this.uploadExcelForm.language,
        file_name: this.lettersFileList[0].name,
        file_path: this.lettersFileList[0].url
      }).then((response) => {
        if (response.data.code === 200) {
          this.uploadExcelVisable = false
          this.developLettersList();
        }
      })
    },
    saveReceiversUpload: function () {
      this.$refs.uploadReceiversForm.validate(valid => {
        if (valid) {
          this.$axios.post('email/receivers/save', {
            country: this.uploadReceiversForm.country,
            product: this.uploadReceiversForm.product,
            file_name: this.receiversFileList[0].name,
            file_path: this.receiversFileList[0].url
          }).then((response) => {
            if (response.data.code === 200) {
              this.uploadReceiversVisable = false
              this.receiversQueryList();
            }
          })
        }
      })
    },
    preview: function (row) {
      this.$axios.get('excel/preview', {
        params: {
          url: row.file_path
        }
      }).then((response) => {
        let code = response.data.code;
        if (code === 200) {
          this.uploadExcelFileName = row.file_name;
          this.uploadExcelData = response.data.data
          this.excelPreviewVisible = true;
        } else {
          this.$notify({
            title: 'error',
            message: response.data.data,
            type: 'error'
          })
        }
      });
    },
    receiversPreview: function (row) {
      this.$axios.get('excel/preview', {
        params: {
          url: row.file_path
        }
      }).then((response) => {
        let code = response.data.code;
        if (code === 200) {
          this.uploadReceiversFileName = row.file_name;
          this.uploadReceiversData = response.data.data
          this.receiversPreviewVisible = true;
        } else {
          this.$notify({
            title: 'error',
            message: response.data.data,
            type: 'error'
          })
        }
      });
    },
    del(row) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('email/develop_letters/delete', {
          id: row.id
        }).then((response) => {
          let code = response.data.code;
          if (code === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.developLettersList();
          } else {
            this.$notify({
              title: 'failed',
              message: response.data.data,
              type: 'error'
            })
          }
        })
      })
    },
    receiversDel(row) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('email/receivers/delete', {
          id: row.id
        }).then((response) => {
          let code = response.data.code;
          if (code === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.receiversQueryList();
          } else {
            this.$notify({
              title: 'failed',
              message: response.data.data,
              type: 'error'
            })
          }
        })
      })
    },
    repliersDel(row) {
      this.$confirm('此操作将永久删除该邮箱, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('email/repliers/delete', {
          id: row.id
        }).then((response) => {
          let code = response.data.code;
          if (code === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.repliersQueryList();
          } else {
            this.$notify({
              title: 'failed',
              message: response.data.data,
              type: 'error'
            })
          }
        })
      })
    },
    download(row) {
      window.location.href = this.$axios.defaults.baseURL + 'email/develop_letters/download?id=' + row.id;
    },
    receiversDownload(row) {
      window.location.href = this.$axios.defaults.baseURL + 'email/receivers/download?id=' + row.id;
    },
    cancelAddRepliers() {
      this.addRepliersVisable = false;
      this.repliersForm = {};
    },
    confirmAddRepliers() {
      this.$axios.post('email/repliers/add', this.repliersForm).then((response) => {
        if (response.data.code === 200) {
          this.$notify({
            title: '添加成功',
            message: '添加成功',
            type: 'success'
          });
          this.addRepliersVisable = false;
          this.repliersForm = {};
          this.repliersQueryList();
        }
      })
    },
    repliersToggleStatus(row) {
      this.$notify({
        title: '提示',
        message: '修改状态不会影响已有的发送计划',
        type: 'info'
      })
      this.$axios.post('email/repliers/toggle_status', {
        id: row.id,
        status: row.status
      }).then((response) => {
        console.log(response);
      })
    },
    cancelAddSenders() {
      this.addSendersVisable = false;
      this.sendersForm = {
        mailer: 'smtp',
        encryption: null,
        host: '',
        port: 25,
        username: '',
        password: ''
      }
    },
    confirmAddSenders() {
      this.email_sender_loading = true;
      // this.$refs.sendersForm.validate(valid => {
      //   if (valid) {

      //   }
      // })
      this.$axios.post('email/senders/add', this.sendersForm).then((response) => {
        if (response.data.code === 200) {
          this.addSendersVisable = false;
          this.sendersForm = {
            mailer: 'smtp',
            encryption: null,
            host: '',
            port: 25,
            username: '',
            password: ''
          }
          this.sendersQueryList();
        } else {
          this.$notify({
            title: '保存失败',
            message: response.data.data,
            type: 'error'
          })
        }
      })
      this.email_sender_loading = false;
    },
    sendersToggleStatus(row) {
      this.$axios.post('email/senders/toggle_status', {
        id: row.id,
        status: row.status
      }).then((response) => {
        this.$notify({
          title: '提示',
          message: '修改不会影响已有的发送计划',
          type: 'info'
        })
      })
    },
    sendersDel(row) {
      this.$confirm('此操作将永久删除该邮箱, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('email/senders/delete', {
          id: row.id
        }).then((response) => {
          let code = response.data.code;
          if (code === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.sendersQueryList();
          } else {
            this.$notify({
              title: 'failed',
              message: response.data.data,
              type: 'error'
            })
          }
        })
      })
    },
    sendersEdit(row) {
      this.editSendersVisable = true;
      this.$axios.get(`email/senders/detail?id=${row.id}`).then((response) => {
        if (response.data.code === 200) {
          this.editSendersForm = response.data.data
        }
      });
    },
    cancelEditSenders() {
      this.editSendersVisable = false;
      this.editSendersForm = {
        mailer: 'smtp',
        encryption: null,
        host: '',
        port: 25,
        username: '',
        password: ''
      }
    },
    confirmEditSenders() {
      this.email_sender_loading = true;
      this.$refs.editSendersForm.validate(valid => {
        if (valid) {
          this.$axios.post('email/senders/save', this.editSendersForm).then((response) => {
            this.email_sender_loading = false;
            if (response.data.code === 200) {
              this.addSendersVisable = false;
              this.editSendersForm = {
                mailer: 'smtp',
                encryption: null,
                host: '',
                port: 25,
                username: '',
                password: ''
              }
              this.editSendersVisable = false;
              this.sendersQueryList();
            } else {
              this.$notify({
                title: '保存失败',
                message: response.data.data,
                type: 'error'
              })
            }
          })
          this.email_sender_loading = false;
        }
      })
    },
    addTask() {
      this.addTaskVisable = true;
    },
    initOptions() {
      this.$axios.get('email/task/options').then((response) => {
        if (response.data.code === 200) {
          this.lettersOptions = response.data.data.letters
          this.receiversOptions = response.data.data.receivers
          this.senderOptions = response.data.data.senders
        }
      })
    },
    taskDelayToggleStatus(delay) {
      this.taskStartTimeVisable = delay;
    },
    cancelAddTask() {
      this.addTaskVisable = false;
      this.taskForm = {
        task_name: '',
        letter_id: '',
        receivers_id: '',
        sender_id: '',
        delay: false,
        start_time: '',
        send_interval: 30,
        send_mode: '普通模式',
        multi_sender_id: '',
        cut_density: 50,
        cut_mode: '顺序',
        round_space: '48',
        mixed: false
      };
      this.current_receiver_count = ''
    },
    confirmAddTask() {
      let combined_senders = Object.values(this.combinedSenders);
      if (this.taskForm.send_mode === '轮换模式') {
        if (this.rest_senders[1] === '' || this.rest_senders[1] === undefined) {
          this.$message({
            title: '操作失败',
            message: '第1轮不能为空',
            type: 'error'
          })
          return false;
        }
        if (combined_senders.length < this.send_rounds) {
          this.$message({
            title: '操作失败',
            message: '总轮数和选择的邮箱数量不符',
            type: 'error'
          })
          return false;
        }
      }
      this.taskForm.combined_senders = combined_senders;
      this.$refs.taskForm.validate(valid => {
        if (valid) {
          this.loading = true;
          this.$axios.post('email/task/add', this.taskForm).then((response) => {
            this.loading = false;
            if (response.data.code === 200) {
              this.$notify({
                title: '操作成功',
                message: '任务创建成功',
                type: 'success'
              })
              this.taskQueryList();
              this.addTaskVisable = false;
            }
          });
        }
      })
    },
    taskToggleStatus(row, index) {
      let notice = row.status ? '开启' : '停止';
      this.$confirm('确定' + notice + '任务吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('email/task/toggle_status', {
          id: row.id,
          status: row.status
        })
      }).catch(() => {
        this.taskList[index].status = !row.status;
      });
    },
    taskDel(row) {
      this.$confirm('确认删除吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('email/task/delete', {
          id: row.id
        }).then((response) => {
          if (response.data.code === 200) {
            this.$notify({
              title: '操作成功',
              message: response.data.data,
              type: 'success'
            })
          } else {
            this.$notify({
              title: '操作失败',
              message: response.data.data,
              type: 'error'
            })
          }
          this.taskQueryList();
        })
      })
    },
    taskView(row) {
      this.detailTaskForm = {};
      this.current_receiver_count = '';
      this.detailLoading = true;
      this.detailTaskLoadingText = '正在读取, 请稍候';
      this.detailTaskVisable = true;
      this.$axios.get(`email/task/detail?id=${row.id}`).then((response) => {
        this.detailLoading = false;
        if (response.data.code === 200) {
          let obj = response.data.data;
          this.detailTaskForm = obj
          this.send_rounds = obj.send_rounds;
          this.receiversSelected(obj.receivers_id);
          this.rest_senders = obj.rest_senders;
          this.detailTaskStartTimeVisable = obj.delay;
        }
      })
    },
    cancelEditTask() {
      this.detailTaskVisable = false;
      this.detailTaskForm = {};
      this.current_receiver_count = '';
    },
    confirmEditTask() {
      let combined_senders = Object.values(this.combinedSenders);
      if (this.detailTaskForm.send_mode === '轮换模式') {
        if (this.rest_senders[1] === '' || this.rest_senders[1] === undefined) {
          this.$message({
            title: '操作失败',
            message: '第1轮不能为空',
            type: 'error'
          })
          return false;
        }
        if (combined_senders.length < this.send_rounds) {
          this.$message({
            title: '操作失败',
            message: '总轮数和选择的邮箱数量不符',
            type: 'error'
          })
          return false;
        }
      }
      this.detailTaskForm.combined_senders = combined_senders;
      this.$refs.detailTaskForm.validate(valid => {
        if (valid) {
          this.detailLoading = true;
          this.detailTaskLoadingText = '正在保存, 请稍候';
          this.$axios.post('email/task/store', this.detailTaskForm).then((response) => {
            this.detailLoading = false;
            if (response.data.code === 200) {
              this.$notify({
                title: '操作成功',
                message: '修改成功',
                type: 'success'
              })
              this.taskQueryList();
              this.detailTaskVisable = false;
            } else {
              this.$notify({
                title: '保存失败',
                message: response.data.data,
                type: 'error'
              })
            }
          });
        }
      })
    },
    recycleRestore(row, tag) {
      var module;
      switch (tag) {
        case 'task':
          module = 'EMAIL_SEND_TASK'

          break;
      }
      this.$confirm('确定还原吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.$axios.post('center/data/recycle_restore', {
          id: row.id,
          module: module
        }).then((response) => {
          let code = response.data.code;
          if (code === 200) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
            this.recycleBin(tag);
          } else {
            this.$notify({
              title: 'failed',
              message: response.data.data,
              type: 'error'
            })
          }
        })
      })
    },
    recycleDel(row, tag) {
      var module;
      switch (tag) {
        case 'task':
          module = 'EMAIL_SEND_TASK'
          break;
      }
      this.$confirm('此操作不可恢复, 确定吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.$axios.post('center/data/recycle_delete', {
          id: row.id,
          module: module
        }).then((response) => {
          let code = response.data.code;
          if (code === 200) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
            this.recycleBin(tag);
          } else {
            this.$notify({
              title: 'failed',
              message: response.data.data,
              type: 'error'
            })
          }
        })
      })
    },
    changeTaskRecycleSize(val) {
      this.taskRecycleSize = val;
      this.recycleBin('task');
    },
    currentTaskRecycleChange(val) {
      this.taskRecycleCurrentPage = val;
      this.recycleBin('task');
    },
    recycleBin(tag) {
      switch (tag) {
        case 'task':
          this.vLoading = true;
          this.taskRecycleBin = true;
          this.$axios.get(`center/data/recycle_list`, {
            params: {
              size: this.taskRecycleSize,
              page: this.taskRecycleCurrentPage,
              module: 'EMAIL_SEND_TASK'
            }
          }).then((response) => {
            this.vLoading = false;
            if (response.data.code === 200) {
              this.taskRecycleBinData = response.data.data.data
              this.taskRecycleTotal = response.data.data.total
            }
          });
          break;
      }
    },
    concatenatedErrors(row) {
      return row.errors.join("<br>");
    },
    concatenatedSenders(row) {
      return row.sender_username.join("<br>");
    },
    concatenatedTurnModeProgress(row) {
      return row.progress.join("<br>");
    },
    concatenatedTurnModeSenders(row) {
      return row.turn_mode_senders.join("<br>");
    },
    concatenatedSentFrom(row) {
      return row.sent_from.join("<br>");
    },
    concatenatedTurnModeSent(row) {
      return row.turn_mode_sent.join("<br>");
    },
    concatenatedTurnModeRead(row) {
      return row.turn_mode_read.join("<br>");
    },
    concatenatedTurnModeUnRead(row) {
      return row.turn_mode_unread.join("<br>");
    },
    concatenatedTurnModeReadPercentage(row) {
      return row.turn_mode_read_percentage.join("<br>");
    },
    receiversSelected(val) {
      var obj = {}
      obj = this.receiversOptions.find(function (i) {
        return i.id === val
      });
      this.current_receiver_count = obj.detail_count
    },
    async showExportSendStats() {
      this.exportSendStatsVisible = true;
      this.exportSendStatsForm = {
        dates: null,
        user: [],
        product: ''
      }
      this.sLoading = true;
      this.screenSentData = [];
      await this.$axios.get(`basic/users/list?query=1`).then((response) => {
        this.sLoading = false;
        if (response.data.code === 200) {
          this.users = response.data.data
        } else {
          this.$notify({
            title: 'failed',
            message: '获取用户列表失败',
            type: 'warning'
          })
        }
      })
      // await this.$axios.get(`email/products`).then((response) => {
      //   if (response.data.code === 200) {
      //     this.products = response.data.data
      //   } else {
      //     this.$notify({
      //       title: 'failed',
      //       message: '获取产品列表失败',
      //       type: 'warning'
      //     })
      //   }
      // })
    },
    exportSendStats() {
      if (this.exportSendStatsForm.dates === null) {
        this.$message({
          type: 'error',
          message: '请选择时间跨度'
        })
        return false;
      }
      this.screenSentData = [];
      this.exportSendStatsLoading = true;
      this.$axios.post(`email/screen_sent_stats`, this.exportSendStatsForm).then((response) => {
        this.exportSendStatsLoading = false;
        if (response.data.code === 200) {
          this.screenSentData = response.data.data;
        }
      })
    },
    saveSendStats() {
      if (this.exportSendStatsForm.dates === null) {
        this.$message({
          type: 'error',
          message: '请选择时间跨度'
        })
        return false;
      }
      if (this.exportSendStatsForm.product === null) {
        this.$message({
          type: 'error',
          message: '请至少输入一个关键词'
        })
        return false;
      }
      this.save_btn_loading = true;
      this.save_btn_disabled = true;
      this.$axios.post(`email/save_sent_stats`, this.exportSendStatsForm).then((response) => {
        this.save_btn_loading = false;
        this.save_btn_disabled = false;
        if (response.data.code === 200) {
          window.location.href = this.$axios.defaults.baseURL + 'files/download?url=' + response.data.data;
        }
      })
    }
  },
  beforeDestroy() {
    clearInterval(this.intervals);
  }
}



// WEBPACK FOOTER //
// ./src/components/Modules/Emails/script.js